'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect, useMemo } from 'react';

import { SegmentPage } from '@flipster/features/src/misc/segment/segment-page';
import { useAuth } from '@flipster/features/src/shared/auth/state';
import { defaultTradFiSymbol } from '@flipster/features/src/shared/rwa';
import { SymbolScope } from '@flipster/features/src/shared/symbol/bunja';
import { tradingSessionBunja } from '@flipster/features/src/shared/trading-suspension/state';
import { useCookie } from '@flipster/react/misc/browser/cookie';
import { CookieKeys } from '@flipster/utils/cookie';

import { countryRestrictionBunja } from '../_misc/country-restriction-dialog/state';
import { commonFormBunja } from '../_misc/order-form/common';
import { tradeSymbolBunja } from '../_misc/symbol';

export const TradePageView = () => {
  const { symbol, symbolInfoAtom, isTradFiInstrumentAtom } = useBunja(tradeSymbolBunja);
  const { priceTypeAtom } = useBunja(commonFormBunja);
  const { isTradableAtom, isReferrerPersistableAtom } = useBunja(countryRestrictionBunja);
  const symbolInfo = useAtomValue(symbolInfoAtom);
  const isTradFi = useAtomValue(isTradFiInstrumentAtom);
  const isTradable = useAtomValue(isTradableAtom);
  const isReferrerPersistable = useAtomValue(isReferrerPersistableAtom);
  const [, setPerpCookie] = useCookie(CookieKeys.ReferrerSymbol);
  const [, setSpotCookie] = useCookie(CookieKeys.SpotReferrerSymbol);
  const [tradFiCookie, setTradFiCookie] = useCookie(CookieKeys.TradFiReferrerSymbol);
  const { isLoggedIn } = useAuth();
  const priceType = useAtomValue(priceTypeAtom);
  const { currentMarketStatusAtom } = useBunja(tradingSessionBunja, [SymbolScope.bind(symbol)]);
  const currentMarketStatus = useAtomValue(currentMarketStatusAtom);

  useEffect(() => {
    if (!symbol || !isLoggedIn) return;
    if (!symbolInfo || symbol !== symbolInfo.symbol) return;
    if (isTradFi && !isTradable && tradFiCookie === symbol) {
      setTradFiCookie(defaultTradFiSymbol, 3);
      return;
    }
    if (!isReferrerPersistable) return;
    if (symbolInfo.isSpot) {
      setSpotCookie(symbol, 3);
      return;
    }
    if (isTradFi) {
      setTradFiCookie(symbol, 3);
      return;
    }
    setPerpCookie(symbol, 3);
  }, [
    isLoggedIn,
    symbol,
    symbolInfo,
    isTradFi,
    isTradable,
    tradFiCookie,
    isReferrerPersistable,
    setSpotCookie,
    setPerpCookie,
    setTradFiCookie,
  ]);

  const context = useMemo(
    () => ({ symbol, tab_type: priceType, market_status: currentMarketStatus }),
    [symbol, priceType, currentMarketStatus],
  );

  return <SegmentPage name='trade_page_view' context={context} />;
};
